import { IAppState } from '../../redux';
import { IServicePeriod } from '../../redux/reducers';

export const selectActiveCalltrackingPeriod = (state: IAppState): IServicePeriod | null => {
  const {
    calltracking: { period },
  } = state;

  return period || null;
};
